import { render, staticRenderFns } from "./Profiling.vue?vue&type=template&id=2c5e0114&scoped=true&"
import script from "./Profiling.vue?vue&type=script&lang=js&"
export * from "./Profiling.vue?vue&type=script&lang=js&"
import style0 from "./Profiling.vue?vue&type=style&index=0&id=2c5e0114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5e0114",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRadio,VRadioGroup,VRow,VSpacer,VTextField})
